import {
  OrderProductsResponseDto,
  SubscriptionListResponseDto,
  OrdersListProductDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import getUrlWithParams from 'commons/utils/getUrlWithParams';
import {
  SubscriptionsEndpoints,
  GET_CUSTOMER_SUBSCRIPTIONS_URL,
  CANCEL_CUSTOMER_SUBSCRIPTION_URL,
  GET_ORDER_PRODUCTS_URL,
  subscriptionsTags,
} from './settings';

export const subscriptionsApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [subscriptionsTags.subscriptionsList],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [SubscriptionsEndpoints.getCustomerSubscriptions]: builder.query<
        SubscriptionListResponseDto,
        { customerId: string }
      >({
        query: ({ customerId }) => ({
          method: 'GET',
          url: GET_CUSTOMER_SUBSCRIPTIONS_URL,
          params: { customerId },
        }),
        providesTags: [subscriptionsTags.subscriptionsList],
      }),
      [SubscriptionsEndpoints.cancelCustomerSubscription]: builder.mutation<
        void,
        { subscriptionId: string }
      >({
        query: ({ subscriptionId }) => ({
          method: 'POST',
          url: getUrlWithParams(CANCEL_CUSTOMER_SUBSCRIPTION_URL, {
            subscriptionId,
          }),
        }),
        invalidatesTags: [subscriptionsTags.subscriptionsList],
      }),
      [SubscriptionsEndpoints.getOrderProducts]: builder.query<
        OrdersListProductDto[],
        { orderId: string }
      >({
        query: ({ orderId }) => ({
          method: 'GET',
          url: getUrlWithParams(GET_ORDER_PRODUCTS_URL, { orderId }),
        }),
        transformResponse: (data: OrderProductsResponseDto) => data.products,
      }),
    }),
  });

export const {
  useGetCustomerSubscriptionsQuery,
  useCancelCustomerSubscriptionMutation,
  useGetOrderProductsQuery,
} = subscriptionsApi;
